import axios from 'axios';
import i18n from '@/i18n';
import { ErrorService } from '@/services/error-service.js';

const DEV_AUTH = process.env.NODE_ENV === 'development' ? true : false;

const AUTH = {
  username: process.env.VUE_APP_LOGIN_API_USERNAME,
  password: process.env.VUE_APP_LOGIN_API_PASSWORD
};


const path = require('path');
const DOMAIN = process.env.VUE_APP_DOMAIN;
const USERGROUP_API_PATH = process.env.VUE_APP_USERGROUP_API_PATH;

if (!DEV_AUTH) {
  axios.defaults.headers.common['X-CSRFToken'] = (name => {
    var re = new RegExp(`(?:^|; )${name}=([^;]+)`); // is `^name` or `; name`
    var value = re.exec(document.cookie);
    return (value != null) ? decodeURIComponent(value[1]) : null;
  })('csrftoken');
}

const usergroupsAPI = {

  async getUsergroupsRoles() {
    const url = new URL(path.join(`${i18n.locale}${USERGROUP_API_PATH}`, `user-group-roles/`), DOMAIN);
    let response;
    try {
      response = await axios.get(url);
      if (response.status === 200) {
        return response.data;
      }
    } catch (err) {
      console.error(err);
      return false;
    }
  },

  async getUsergroupsTypes() {
    const url = new URL(
      path.join(`${i18n.locale}${USERGROUP_API_PATH}`, `user-group-types/`),
      DOMAIN
    );
    const response = await axios.get(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },

  async getUsergroupsList(usergroupTypes, searchQuery, controller) {
    let url = new URL(
      path.join(`${i18n.locale}${USERGROUP_API_PATH}`, `user-groups/?usergroup_types=${usergroupTypes.join(',')}`),
      DOMAIN
    );
    if (searchQuery) {
      url = url + `&search=${searchQuery}`;
    }
    const response = await axios.get(url, {
      ...DEV_AUTH && { auth: AUTH },
      ...controller && { signal: controller.signal }
    });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },

  async createUsergroup(data) {
    const url = new URL(
      path.join(`${i18n.locale}${USERGROUP_API_PATH}`, `user-groups/`),
      DOMAIN
    );
    const response = await axios.post(url, data, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 201) {
      return response.data;
    }
    return false;
  },

  async updateUsergroup(id, data) {
    const url = new URL(
      path.join(`${i18n.locale}${USERGROUP_API_PATH}`, `user-groups/${id}/`),
      DOMAIN
    );
    const response = await axios.put(url, data, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },

  async getUsergroupMembers(id) {
    const url = new URL(path.join(`${i18n.locale}${USERGROUP_API_PATH}`, `user-groups/${id}/members/`), DOMAIN);
    const response = await axios.get(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },

  async addUserToUsergroup(usergroupId, data) {
    try {
      const url = new URL(path.join(`${i18n.locale}${USERGROUP_API_PATH}`, `user-groups/${usergroupId}/registered/`), DOMAIN);
      const response = await axios.post(url, data, { ...DEV_AUTH && { auth: AUTH } });
      if (response.status === 201) {
        return response;
      }
    } catch (err) {
      ErrorService.onError(err.response);
      return false;
    }
  },

  async removeUserFromUsergroup(usergroupId, userId) {
    try {
      const url = new URL(
        path.join(
          `${i18n.locale}${USERGROUP_API_PATH}`,
          `/user-groups/${usergroupId}/members/${userId}/`
        ),
        DOMAIN
      );
      const response = await axios.delete(url, { ...DEV_AUTH && { auth: AUTH } });
      if (response.status === 204) {
        return response.data;
      }
      return false;
    } catch (err) {
      ErrorService.onError(err.response);
      return false;
    }
  },

  async setUsergroupThumbnail(id, data) {
    const url = new URL(
      path.join(
        `${i18n.locale}${USERGROUP_API_PATH}`,
        `user-groups/${id}/thumbnail/`
      ),
      DOMAIN
    );
    const response = await axios.put(url, data, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },

  addParentToUsergroup(usergroupId, parentId) {
    const url = new URL(
      path.join(
        `${i18n.locale}${USERGROUP_API_PATH}`,
        `user-groups/${usergroupId}/parents/`
      ),
      DOMAIN
    );
    return axios.post(
      url,
      { parent_id: parentId},
      { ...DEV_AUTH && { auth: AUTH }
    });
  }
}

export default usergroupsAPI;
